// extracted by mini-css-extract-plugin
module.exports = {"root":"media-gallery_root__yV8T8","grid":"media-gallery_grid__AqZRX","threecol":"media-gallery_threecol__iUwQ6","gap":"media-gallery_gap__W8VUL","item":"media-gallery_item__J0XsO"};